import axios from 'axios';

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 504) {
      error.message = 'The request took too long and timed out.';
    }
    return Promise.reject(error);
  }
);

/**
 * Base class fro APIs
 */
class ApiBase {
  API_URL = 'v1';

  /**
   * Get standard headers for API calls
   */
  getHeaders() {
    const token = sessionStorage.getItem('token');
    const tenant = sessionStorage.getItem('tenant');

    return {
      'Content-Type': 'application/json',
      'IC-USER-CLIENT': Buffer.from(tenant).toString('base64'),
      'X-IC-ACCESS-TOKEN': token
    };
  }
}

export default ApiBase;
